import { render } from "./WorkTabList.vue?vue&type=template&id=4a1f60e8"
import script from "./WorkTabList.vue?vue&type=script&lang=js"
export * from "./WorkTabList.vue?vue&type=script&lang=js"

import "./WorkTabList.vue?vue&type=style&index=0&id=4a1f60e8&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__